export const Fields = [
  {
    id: 1,
    name: 'QRCode',
    title: 'QRCode',
    type: 'QRCode',
    value: '',
    width: 0,
    height: 0,
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
  },
  {
    id: 2,
    name: 'personnel_image',
    title: 'عکس پرسنلی',
    type: 'image',
    width: 0,
    height: 0,
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
  },
  {
    id: 3,
    name: 'name',
    title: 'نام',
    type: 'string',
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
    bold: false,
  },
  {
    id: 4,
    name: 'last_name',
    title: 'نام خانوادگی',
    type: 'string',
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
    bold: false,
  },
  {
    id: 5,
    name: 'name_en',
    title: 'نام انگلیسی',
    type: 'string',
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
    bold: false,
  },
  {
    id: 6,
    name: 'last_name_en',
    title: 'نام خانوادگی انگلیسی',
    type: 'string',
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
    bold: false,
  },
  {
    id: 7,
    name: 'father_name',
    title: 'نام پدر',
    type: 'string',
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
    bold: false,
  },
  {
    id: 8,
    name: 'father_name_en',
    title: 'نام پدر انگلیسی',
    type: 'string',
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
    bold: false,
  },
  {
    id: 9,
    name: 'national_card_id',
    title: 'کد ملی',
    type: 'string',
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
    bold: false,
  },
  {
    id: 10,
    name: 'mobild',
    title: 'شماره همراه',
    type: 'string',
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
    bold: false,
  },
  {
    id: 11,
    name: 'birthday',
    title: 'تاریخ تولد',
    type: 'date',
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
    bold: false,
  },

  {
    id: 12,
    name: 'province_living',
    title: 'استان محل زندگی',
    type: 'province',
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
    bold: false,
  },
  {
    id: 13,
    name: 'gender',
    title: 'جنسیت',
    type: 'string',
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
    bold: false,
  },
  {
    id: 14,
    name: 'field',
    title: 'رشته',
    type: 'string',
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
    bold: false,
  },
  {
    id: 15,
    name: 'weight',
    title: 'وزن',
    type: 'string',
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
    bold: false,
  },
  {
    id: 16,
    name: 'sid',
    title: 'سمت',
    type: 'string',
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
    bold: false,
  },
  {
    id: 17,
    name: 'insurnce',
    title: 'تاریخ پایان بیمه',
    type: 'string',
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
    bold: false,
  },
  {
    id: 18,
    name: 'competition_name',
    title: 'عنوان مسابقه',
    type: 'string',
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
    bold: false,
  },
  {
    id: 19,
    name: 'rank',
    title: 'مقام',
    type: 'string',
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
    bold: false,
  },
  {
    id: 20,
    name: 'medal',
    title: 'مدال',
    type: 'string',
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
    bold: false,
  },
  {
    id: 21,
    name: 'competition_province_id',
    title: 'استان محل برگزاری',
    type: 'string',
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
    bold: false,
  },
  {
    id: 22,
    name: 'now',
    title: 'تاریخ امروز',
    type: 'string',
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
    bold: false,
  },
  {
    id: 23,
    name: 'end_at',
    title: 'تاریخ پایان مسابقه',
    type: 'string',
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
    bold: false,
  },
  {
    id: 24,
    name: 'sku',
    title: 'شناسه مسابقه',
    type: 'string',
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
    bold: false,
  },
  {
    id: 25,
    name: 'full_name',
    title: 'نام و نام خانوادگی',
    type: 'string',
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
    bold: false,
  },
  {
    id: 26,
    name: 'age',
    title: 'رده سنی',
    type: 'string',
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
    bold: false,
  },
];
